import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import ProtectedLayout from "../../components/ProtectedLayout/ProtectedLayout";
import UserContext from "../../context/UserContext/UserContext";

const ProtectedRoute = ({ children, withLayout = true }) => {
  const user = useContext(UserContext)[0];

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return withLayout ? <ProtectedLayout>{children}</ProtectedLayout> : children;
};

export default ProtectedRoute;
